// Translation: German > Notifications
const notifications = Object.freeze({})

// Export
export default notifications
